<template>
    <div :style="styles" class="contenedorMIN">
        
        <v-sheet class="hexagonMIN" />
        <v-sheet class="subtituloMIN text-center" :width="sizeHexa-5" color="transparent">
            <span class="textDashboard" > {{ subtitle }} </span>
        </v-sheet>
        <span class="tituloMIN"> {{ (parseFloat(title)*100).toFixed()}}% </span>
    </div>
    
</template>

<script setup lang="ts">
import { computed, ref, onMounted, watch } from 'vue';
import { COLOR } from '@/constants/colors';

const props = defineProps({
    title       : { type: String, required: true },
    secondInfo  : { type: Number, default: 0 },
    color       : { type: String, required: true },
    subtitle    : { type: String, required: true },
    sizeHexa    : { type: Number, default: 110 },
    sizeTitle   : { type: Number, default: 25 },
    sizeSubTi   : { type: Number, default: 15 },
    minValue    : { type: Number, default: 0.6 },
    maxValue    : { type: Number, default: 0.9 },
})

const finalNumber   = computed(() => props.title);
const sizeHexa      = computed(() => props.sizeHexa);
const sizeTitle     = computed(() => props.sizeTitle);
const sizeSubTi     = computed(() => props.sizeSubTi);
const minValue      = computed(() => props.minValue);
const maxValue      = computed(() => props.maxValue);
const finalColor    = ref('');
const colorHexagon  = computed(() => finalColor.value);
const colorText     = ref('')
const finalColorT   = computed(() => colorText.value)

const getColorByNumber = () => {  
    let number = parseFloat(finalNumber.value);
    if (number >= maxValue.value) finalColor.value = COLOR.green
    if (number < maxValue.value && number >= minValue.value ) finalColor.value = COLOR.yellow
    if (number < minValue.value ) finalColor.value = COLOR.red;
    getColorText(finalColor.value)
}

const getColorText = (color:string) => {
    let colorT = '#FFFFFF';
    if(color === COLOR.yellow) colorT = '#000000';
    colorText.value = colorT;
}

watch(finalNumber,() => {
    getColorByNumber()
} )
watch(minValue,() => {
    getColorByNumber()
} )
watch(maxValue,() => {
    getColorByNumber()
} )

watch(finalColor, (color:string) => {
    let colorT = '#FFFFFF';
    if(color === COLOR.yellow) colorT = '#000000';

    colorText.value = colorT;
})

const styles = computed(() =>  ({
    '--varColor' : colorHexagon.value,
    '--varSizeHexa': `${sizeHexa.value}px`,
    '--varSizeTitle': `${sizeTitle.value}px`,
    '--varSizeSubTi': `${sizeSubTi.value}px`,
    '--varColorText' : finalColorT.value
}))

onMounted(() => {
    getColorByNumber()
})

</script>

<style scoped>

.contenedorMIN{
    position: relative;
    width: calc(var(--varSizeHexa) * 0.645);
    height: var(--varSizeHexa);
    margin: 1px 15px;
}

.contenedorMIN .hexagonMIN {
  cursor: pointer;
  position: absolute;
  width: calc(var(--varSizeHexa) * 0.645);
  height: var(--varSizeHexa);
  background-image: linear-gradient(90deg, var(--varColor),var(--varColor));
  border-radius: calc(var(--varSizeHexa) / 10);
  transition: transform 400ms ease;
  
}

.contenedorMIN:hover .hexagonMIN{
    transform: rotate(30deg);
}

.contenedorMIN .hexagonMIN:before, .contenedorMIN .hexagonMIN:after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: inherit;
    height: inherit;
    background-image: inherit;
    border-radius: inherit;
}

.contenedorMIN .hexagonMIN:before{
    transform: rotate(60deg);
}

.contenedorMIN .hexagonMIN:after{
    transform: rotate(-60deg);
}

.contenedorMIN  .tituloMIN{
    position: absolute;
    z-index: 2;
    top: 60%;
    left: 47%;
    transform: translate(-45%, -50%);
    cursor: pointer;
    font-family: 'Poppins',sans-serif;
    font-weight: bold;
    font-size: var(--varSizeTitle);
    text-shadow: 2px 3px 3px rgba(0,0,0,0.2);
    color: var(--varColorText);
}

.contenedorMIN  .subtituloMIN{
    position: absolute;
    z-index: 2;
    top: 25%;
    left: -24%;
    /* transform: translate(-60%, -50%); */
    cursor: pointer;
}

.subtituloMIN .textDashboard{
    font-family: 'Poppins',sans-serif;
    font-weight: 400;
    color: var(--varColorText);
    font-size: var(--varSizeSubTi);

}



</style>